import {useEffect, useRef, useState, useCallback} from "react";
import useCanvas from "./useCanvas";
import {initDevice, reportEvent} from "../../../../../utils";
import {Stream} from "../../../utils/helpers/Stream";
import {documentValidator} from "../../../../../services/documentValidator";
import {base64ToBlob, createCanvas, createBase64} from "../../../utils/canvas";
import {startCamera, stopCamera} from "../../../utils";
import {useNavigate} from "react-router-dom";
import {SDK_EVENT_KEYS} from "../../../../../utils/logService";

let CONFIG;
let TIME_TO_CAPTURE_MANUAL = 20;
let TIME_TO_CHANGE_MESSAGE_ERROR = 20000;
// MODIFICADO: Cambiado de 200ms a 300ms para enviar imágenes cada 300ms al servicio documentValidator
let FRAME_THROTTLE_MS = 300;

export function isMovil() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

let timer;
let lastFrameSentTime = 0;

export default function useCamera({
    containerAdo,
    configValue,
    configLoading,
    videoRef,
    canvasRef,
    guideAdo,
    textPreviewBack,
    textPreview,
    imgBack,
    takeManual,
    cameraToggle
}) {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    const {getFaces} = useCanvas(showStep);
    const [loading, setLoading] = useState(true);
    const [cameraIsReady, setCameraIsReady] = useState(false);
    const [isImageValidate, setImageValidate] = useState(false);
    const [typeCapture, setTypeCapture] = useState('');
    const [ocr, setOcr] = useState('');
    const [isCard, setIsCard] = useState('');
    const videoInitRef = useRef(null);
    const finished = useRef(null);
    const initProcess = useRef(null);
    const canvasPreviewRef = useRef(null);
    const canvasCroppedImageRef = useRef(null);
    const timerRef = useRef(0);
    const markRef = useRef(null);
    const takeOneManualPhoto = useRef(true);
    const inputRef = useRef(null);
    const takeManualCaptured = useRef(false);

    const [capturedImageBack, setCapturedImageBack] = useState(null);
    const [step, setStep] = useState('');
    const [indicatorRotate, setIndicatorRotate] = useState(true);
    const [stepHistory, setStepHistory] = useState([]);
    const [seconds, setSeconds] = useState(0);
    const [currentStream, setCurrentStream] = useState(null);
    const [errorCaptureManual, setErrorCaptureManual] = useState({
        show: false,
        message: '',
    });
    const [showModalCaptureManual, setShowModalCaptureManual] = useState(false);
    const [showInstructionsCameraNative, setShowInstructionsCameraNative] = useState(false);

    const urlTracer = params.urlTracer;
    const processId = params.processId;
    const emitReadyCam = params.emitReadyCam || 'false';
    const documentType = params.documentType;
    const codeTransaction = params.codeTransaction;

    const captured = useRef(false);
    const callbackRef = useRef(null);
    const [detectorStatus, setDetectorStatus] = useState('waiting');
    const isManager = params.isManager || 'false';
    const navigate = useNavigate();

    const batchSize = 5; // MODIFICADO: Cambiado de 3 a 5 frames
    const isAutoCaptureStopped = useRef(false);
    const [cameraInitialized, setCameraInitialized] = useState(false);
    const [permissionsGranted, setPermissionsGranted] = useState(false);
    const streamInitialized = useRef(false);

    function goToManager() {
        if (isManager === 'true') {
            navigate(-1);
        }
    }

    async function onReportEvent(eventType, message = {}) {
        if (!urlTracer) return;
        try {
            await reportEvent(urlTracer, processId, eventType, message);
        } catch (e) {}
    }

    function initTimer() {

        // automatica con timeout para manual
        if (configValue?.configCamera?.onlyAutomatic === false && configValue?.configCamera?.onlyManual === false) {
            timer = setInterval(() => {
                timerRef.current = timerRef.current + 1;
                setSeconds(prevState => prevState + 1);
            }, 1000);
            return
        }

        // automatica sin timeout
        if (!configValue?.configCamera?.onlyAutomatic) {
            timer = setInterval(() => {
                timerRef.current = timerRef.current + 1;
                setSeconds(prevState => prevState + 1);
            }, 1000);
        }
    }

    function rotateBase64Image(base64Image) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const width = img.width;
                const height = img.height;

                const originalCanvas = document.createElement('canvas');
                originalCanvas.width = width;
                originalCanvas.height = height;

                const contextOriginal = originalCanvas.getContext('2d');
                contextOriginal.drawImage(img, 0, 0, originalCanvas.width, originalCanvas.height);

                const rotatedCanvas = document.createElement('canvas');
                rotatedCanvas.width = height;
                rotatedCanvas.height = width;
                const rotatedContext = rotatedCanvas.getContext('2d');
                rotatedContext.translate(0, width);
                rotatedContext.rotate(-Math.PI / 2);
                rotatedContext.drawImage(originalCanvas, 0, 0);

                resolve(rotatedCanvas.toDataURL('image/jpeg', 0.5));
            };
            img.onerror = reject;
            img.src = base64Image;
        });
    }
    async function callbackAutoCapturing({image}) {
        if (!captured.current && !isAutoCaptureStopped.current) {
            if (guideAdo.current) {
                guideAdo.current.style.border = `4px solid ${configValue.styles.successColor || '#ACFFB7'}`;
                if (textPreview.current) {
                    textPreview.current.innerText = configValue?.statusMessages?.SuccesCapture || 'Documento capturado';
                    textPreview.current.style.backgroundColor = configValue?.styles?.successColor || '#ACFFB7';
                    textPreview.current.style.color = 'white';
                    textPreview.current.style.padding = '10px';
                    textPreview.current.style.borderRadius = '10px';
                    textPreview.current.style.display = 'flex';
                    textPreview.current.style.alignItems = 'center';
                    textPreview.current.style.justifyContent = 'center';
                }
                if (textPreviewBack.current) {
                    textPreviewBack.current.innerText = configValue?.statusMessages?.SuccesCapture || 'Documento capturado';
                    textPreviewBack.current.style.backgroundColor = configValue?.styles?.successColor || '#ACFFB7';
                    textPreviewBack.current.style.color = 'white';
                    textPreviewBack.current.style.padding = '10px';
                    textPreviewBack.current.style.borderRadius = '10px';
                    textPreviewBack.current.style.display = 'flex';
                    textPreviewBack.current.style.alignItems = 'center';
                    textPreviewBack.current.style.justifyContent = 'center';
                }
            }
            captured.current = true;
            const streamRef = Stream.getInstance();

            // Detener el stream
            if (streamRef) {
                streamRef.dropStream();
            }

            clearInterval(timer);
            let imageRotated = image;
            imageRotated = await rotateBase64Image(image);
            setTimeout(() => {
                responseToHost(1, imageRotated, imageRotated);
            }, 1000);
        }
    }

    async function startCameraDesktop(cameraType) {
        const constraintsDesktop = {video: true};
        try {
            onReportEvent(SDK_EVENT_KEYS.InitConfigCamera).catch();
            onReportEvent(SDK_EVENT_KEYS.ApplyConstraints).catch();
            onReportEvent(SDK_EVENT_KEYS.GetCameraPermissions).catch();
            const stream = await navigator.mediaDevices.getUserMedia(constraintsDesktop);
            onReportEvent(SDK_EVENT_KEYS.GetCameraPermissionsSuccess).catch();
            const videoTrack = stream.getVideoTracks()[0];
            videoRef.current.srcObject = stream;
            setTimeout(async () => {
                const video = videoRef.current;
                const canvas = canvasRef.current;
                const canvasContext = canvas.getContext('2d', {
                    willReadFrequently: true,
                    alpha: false
                });
                canvasContext.imageSmoothingEnabled = true;
                canvasContext.imageSmoothingQuality = 'high';
                video.muted = true;
                onReportEvent(SDK_EVENT_KEYS.ServiceCameraOpen).catch();
                const streamProperties = {
                    device: initDevice(),
                    modelPath: '/models',
                    croppedImage: true,
                    urlService: configValue.urlService,
                    isFront,
                    documentType,
                    processId,
                    useRegula: configValue?.useRegula || 'false',
                    config: configValue,
                };
                const streamRef = Stream.getInstance(streamProperties);
                streamRef.updateHtmlElements(videoRef.current, canvasRef.current, textPreview, textPreviewBack, configValue);
                streamRef.setFaceDetection(true);
                streamRef.setCallbackAutoCapturing(callbackAutoCapturing);
                streamRef.setCallbackFaceDetectionErrors(({status}) => {
                    if (guideAdo.current && takeManualCaptured.current === false) {
                        containerAdo.current.classList.add("danger");
                    } else {
                        containerAdo.current.classList.remove("danger");
                    }
                });
                onReportEvent(SDK_EVENT_KEYS.InitConfigValues).catch();
                await setConfigValues();
                onReportEvent(SDK_EVENT_KEYS.ApplyConfigValue).catch();
                initTimer();
                canvas.width = video.videoWidth || 1920;
                canvas.height = video.videoHeight || 1080;
                guideAdo.current.style.transform = 'scale(1)';
                setLoading(false);
                await streamRef.startDetection();
                onReportEvent(SDK_EVENT_KEYS.InitShowGuide).catch();
                showGuide(true);
                onReportEvent(SDK_EVENT_KEYS.EndShowGuide).catch();
            }, 800);
        } catch (error) {
            if (error.message === 'Permission denied') {
                onReportEvent(SDK_EVENT_KEYS.GetCameraPermissionsDenied).catch();
            }
            onReportEvent(SDK_EVENT_KEYS.ConfigCameraError).catch();
            setLoading(false);
            responseToHostError(cameraType, error.message);
        }
    }

    function showGuide(show = true) {
        if (!guideAdo.current || !imgBack.current || !takeManual.current || !videoRef.current) return;
        guideAdo.current.style.opacity = show ? '1' : '0';
        imgBack.current.style.opacity = show ? CONFIG?.closeIcon?.show !== true ? '0' : '1' : '0';
        if (cameraToggle && cameraToggle.current && CONFIG?.cameraToggle?.show !== false) {
            cameraToggle.current.style.opacity = show ? '1' : '0';
        }
        takeManual.current.style.opacity = show ? '1' : '0';
        videoRef.current.style.opacity = show ? '1' : '0';
    }

    const changeGuideToDanger = useCallback(() => {
        if (!containerAdo.current) return;
        containerAdo.current.classList.add("danger");
        if (textPreview.current) {
            textPreview.current.innerText = CONFIG?.messages?.messageFrontTimeout || 'Úbica la parte de adelante tu documento y toma la foto';
            setTimeout(() => {
                if (containerAdo.current && textPreview.current) {
                    containerAdo.current.classList.remove("danger");
                    textPreview.current.innerText = CONFIG?.messages?.messageFrontTimeout || 'Úbica la parte de adelante tu documento y toma la foto';
                }
            }, TIME_TO_CHANGE_MESSAGE_ERROR);
        }
        if (textPreviewBack.current) {
            textPreviewBack.current.innerText = CONFIG?.messages?.messageBackTimeout || 'Úbica la parte de atrás de tu cédula y toma la foto';
            setTimeout(() => {
                if (containerAdo.current && textPreviewBack.current) {
                    containerAdo.current.classList.remove("danger");
                    textPreviewBack.current.innerText = CONFIG?.messages?.messageBackTimeout || 'Úbica la parte de atrás de tu cédula y toma la foto';
                }
            }, TIME_TO_CHANGE_MESSAGE_ERROR);
        }
    }, []);

    function reduceImageQuality(blob, quality) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = function() {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                canvas.toBlob((reducedBlob) => {
                    resolve(reducedBlob);
                }, 'image/webp', quality);
            };
            img.onerror = function(err) {
                reject(err);
            };
            img.src = URL.createObjectURL(blob);
        });
    }


    async function takeManualPhoto() {
        onReportEvent(SDK_EVENT_KEYS.CardCaptureInitCaptureManual).catch();
        showGuide(false);
        setLoading(true);
        // Protección contra clics múltiples
        if (!takeOneManualPhoto.current) {
            return;
        }

        // Validar que el video esté disponible
        if (!videoRef.current || !videoRef.current.srcObject) {
            console.error('Video no disponible para captura');
            return;
        }

        onReportEvent(SDK_EVENT_KEYS.CardCaptureTakePhoToManual).catch();
        takeOneManualPhoto.current = false;
        isAutoCaptureStopped.current = true;
        showGuide(false);
        takeManual.current.style.display = 'none'
        try {
            setLoading(true);
            const enableBatch = configValue?.documentValidator?.enable_batch === 'true';

            if (enableBatch) {
                // MODO BATCH: Capturar 4-5 frames rápidamente
                const capturedFrames = [];

                for (let i = 0; i < batchSize; i++) {
                    // Verificar que el video siga disponible en cada iteración
                    if (!videoRef.current || !videoRef.current.srcObject) {
                        throw new Error('Video no disponible durante captura batch');
                    }

                    const base64Image = createBase64(videoRef);
                    const blobImage = await base64ToBlob(base64Image);
                    capturedFrames.push(blobImage);

                    // Pequeño delay entre capturas para obtener frames diferentes
                    if (i < batchSize - 1) {
                        await new Promise(resolve => setTimeout(resolve, 100));
                    }
                }

                onReportEvent(SDK_EVENT_KEYS.CaptureFrame).catch();
                onReportEvent(SDK_EVENT_KEYS.FrameToBase64).catch();
                onReportEvent(SDK_EVENT_KEYS.FrameSend).catch();

                const response = await documentValidator({
                    base64Data: null,
                    urlService: configValue.urlService,
                    isFront,
                    documentType,
                    processId,
                    config: configValue,
                    batchImages: capturedFrames
                });

                onReportEvent(SDK_EVENT_KEYS.FrameSuccess).catch();
                setLoading(false);

                if (response.data.quality && response.status === 200) {
                    const finalImage = await rotateBase64Image(response.data.images?.original) || capturedFrames[0];
                    responseToHost(isFront === 'true' ? 1 : 2, finalImage, finalImage);
                } else {
                    changeGuideToDanger();
                    showGuide(true);
                    takeOneManualPhoto.current = true;
                }
            } else {
                // MODO NORMAL: Capturar solo 1 frame
                const base64Image = createBase64(videoRef);
                onReportEvent(SDK_EVENT_KEYS.CaptureFrame).catch();
                const blobImage = await base64ToBlob(base64Image);
                onReportEvent(SDK_EVENT_KEYS.FrameToBase64).catch();
                onReportEvent(SDK_EVENT_KEYS.FrameSend).catch();

                if (configValue?.configCamera) {
                    if (configValue?.configCamera?.validateDocument) {
                        const response = await documentValidator({
                            base64Data: blobImage,
                            urlService: configValue.urlService,
                            isFront,
                            documentType,
                            processId,
                            config: configValue
                        });

                        onReportEvent(SDK_EVENT_KEYS.FrameSuccess).catch();
                        setLoading(false);

                        if (response.data.quality && response.status === 200) {
                            let image = base64Image
                            if (configValue?.documentValidator?.return_original) {
                                image = response?.data?.images?.original || base64Image
                            }
                            const finalImage = await rotateBase64Image(image) || base64Image;
                            responseToHost(isFront === 'true' ? 1 : 2, finalImage, finalImage);
                        } else {
                            changeGuideToDanger();
                            showGuide(true);
                            takeOneManualPhoto.current = true;
                            takeManual.current.style.display = 'flex'
                        }
                    } else {
                        const finalImage = await rotateBase64Image(base64Image);
                        setLoading(false);
                        responseToHost(isFront === 'true' ? 1 : 2, finalImage, finalImage);
                    }
                } else {
                    const response = await documentValidator({
                        base64Data: blobImage,
                        urlService: configValue.urlService,
                        isFront,
                        documentType,
                        processId,
                        config: configValue
                    });

                    onReportEvent(SDK_EVENT_KEYS.FrameSuccess).catch();
                    setLoading(false);

                    if (response.data.quality && response.status === 200) {
                        let image = base64Image
                        if (configValue?.documentValidator?.return_original) {
                            image = response?.data?.images?.original || base64Image
                        }
                        const finalImage = await rotateBase64Image(image) || base64Image;
                        responseToHost(isFront === 'true' ? 1 : 2, finalImage, finalImage);
                    } else {
                        changeGuideToDanger();
                        showGuide(true);
                        takeOneManualPhoto.current = true;
                        takeManual.current.style.display = 'flex'
                    }
                }


            }
        } catch (e) {
            console.error('Error en captura manual:', e);
            onReportEvent(SDK_EVENT_KEYS.FrameError, {error: e.message}).catch();
            setLoading(false);
            // IMPORTANTE: Restaurar el estado para permitir reintentos
            showGuide(true);
            takeOneManualPhoto.current = true;

            // Solo llamar a responseToHostError si es un error crítico
            // Si es un error de validación, permitir reintentar
            if (e.message && !e.message.includes('quality')) {
                responseToHostError(isFront === 'true' ? 'Frontal' : 'Trasera', e.message);
            }
        }
    }

    function showStep(message, show = true) {
        if (show) {
            setStepHistory(prevState => [...prevState, message]);
            setStep(message);
        }
    }

    const platform = params.platform || 'web';

    function checkKeywords(text, keywords) {
        const words = keywords.toLowerCase().split(' ');
        const lowerText = text.replace(/[^a-zA-Z0-9-\s]/g, "").toLowerCase();
        for (const word of words) {
            if (lowerText.includes(word)) {
                return true;
            }
        }
        return false;
    }

    function responseToHost(type, image, imageCropped) {
        finished.current = true;
        if (videoRef.current) {
            videoRef.current.style.display = 'none';
        }
        if (guideAdo.current) {
            guideAdo.current.style.display = 'none';
        }
        if (textPreview.current) {
            textPreview.current.style.display = 'none';
        }
        if (textPreviewBack.current) {
            textPreviewBack.current.style.display = 'none';
        }
        stopCamera(videoRef);
        if (debug === 'true') {
            const imageref = document.getElementById("imgResult");
            imageref.src = imageCropped;
            imageref.style.display = 'block';
            const videoContainerRef = document.getElementById("container-ado-camera");
            if (videoContainerRef) {
                videoContainerRef.style.display = 'none';
            }
            imgBack.current.style.display = 'none';
        }
        onReportEvent(SDK_EVENT_KEYS.SendToHost).catch();
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'success',
                step: type === 1 ? 'frontCapture' : 'backCapture',
                data: image,
                cropped: image
            }));
            goToManager();
            return;
        }
        if (platform === 'android') {
            window.ResponseAdo.handleEvent(JSON.stringify({
                type: 'success',
                step: type === 1 ? 'frontCapture' : 'backCapture',
                data: image,
                cropped: image
            }));
            goToManager();
            return;
        }
        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'success',
                step: type === 1 ? 'frontCapture' : 'backCapture',
                data: image,
                cropped: image
            }));
            goToManager();
            return;
        }
        window.parent.postMessage(
            JSON.stringify({
                origin: 'card-capture',
                type: 'success',
                step: type === 1 ? 'frontCapture' : 'backCapture',
                data: image,
                cropped: image
            }),
            '*'
        );
        goToManager();
    }

    function responseToHostError(type, message) {
        finished.current = true;
        if (videoRef.current) {
            videoRef.current.style.display = 'none';
        }
        if (guideAdo.current) {
            guideAdo.current.style.display = 'none';
        }
        if (textPreview.current) {
            textPreview.current.style.display = 'none';
        }
        if (textPreviewBack.current) {
            textPreviewBack.current.style.display = 'none';
        }
        stopCamera(videoRef);
        onReportEvent(SDK_EVENT_KEYS.SendToHost).catch();
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'failure',
                step: message,
                data: '',
            }));
            goToManager();
            return;
        }
        if (platform === 'android') {
            window.ResponseAdo.handleEvent(JSON.stringify({
                type: 'failure',
                step: message,
                data: ''
            }));
            goToManager();
            return;
        }
        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'failure',
                step: message,
                data: ''
            }));
            goToManager();
            return;
        }
        window.parent.postMessage(
            JSON.stringify({
                origin: 'card-capture',
                type: 'failure',
                step: message,
                data: '',
            }),
            '*'
        );
        goToManager();
    }

    function goBack() {
        setOcr('clicked back');
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }));
            goToManager();
            return;
        }
        if (platform === 'android') {
            window.FinishClose.goBack();
            goToManager();
            return;
        }
        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }));
            goToManager();
            return;
        }
        window.parent.postMessage(
            JSON.stringify({
                origin: 'card-capture',
                type: 'success',
                step: 'back',
                data: '',
            }),
            '*'
        );
        goToManager();
    }

    const isFront = params.isFront || 'true';
    const debug = params.debug || 'false';
    const projectName = params.projectName || 'default';

    async function setConfigValues() {
        try {
            TIME_TO_CAPTURE_MANUAL = configValue.timeout;
            CONFIG = configValue;
            if (configValue?.styles?.takePhotoColor) {
                takeManual.current.style.border = `4px solid ${configValue?.styles?.takePhotoColor}`;
                const innerDiv = takeManual?.current?.querySelector('.take-manual-inner');
                innerDiv.style.background = configValue?.styles?.takePhotoColor;
            }
            if (textPreview.current) {
                textPreview.current.innerText = configValue.messages.messageFront;
            }
            if (textPreviewBack.current) {
                textPreviewBack.current.innerText = configValue.messages.messageBack;
            }
            if (configValue?.closeIcon && imgBack.current) {
                imgBack.current.innerHTML = '';
                if (configValue?.closeIcon?.url) {
                    imgBack.current.insertAdjacentHTML("afterbegin", `<img alt="img-back" style="width: 100%" src="${configValue?.closeIcon?.url}"/>`);
                    imgBack.current.style.height = `${configValue?.closeIcon?.size || '30px'}`;
                    imgBack.current.style.width = `${configValue?.closeIcon?.size || '30px'}`;
                } else {
                    imgBack.current.innerText = "X";
                    imgBack.current.style.fontSize = `${configValue?.closeIcon?.size || '30px'}`;
                    imgBack.current.style.color = `${configValue?.closeIcon?.color || 'white'}`;
                }
            }
            if (!isMovil()) {
                videoRef.current.style.border = `4px solid ${configValue.styles.guideColor}`;
            }
        } catch (e) {}
    }

    const updateDetectorStatus = useCallback((status, quality = false) => {
        setDetectorStatus(status);
        if (textPreview.current) {
            textPreview.current.innerText = configValue?.statusMessages?.[status] || configValue?.messages?.messageFront;
            if (quality) {
                textPreview.current.style.backgroundColor = 'white';
                textPreview.current.style.color = configValue?.styles?.successColor || '#ACFFB7';
                textPreview.current.style.display = 'flex';
                textPreview.current.style.alignItems = 'center';
                textPreview.current.style.justifyContent = 'center';
                textPreview.current.style.padding = '10px';
                textPreview.current.style.borderRadius = '10px';
                textPreview.current.style.margin = '10px';
                if (!textPreview.current.querySelector('.check-icon')) {
                    const checkIcon = document.createElement('span');
                    checkIcon.innerHTML = '✓';
                    checkIcon.className = 'check-icon';
                    checkIcon.style.marginLeft = '10px';
                    checkIcon.style.fontSize = '20px';
                    checkIcon.style.fontWeight = 'bold';
                    textPreview.current.appendChild(checkIcon);
                }
            } else {
                textPreview.current.style.backgroundColor = '';
                textPreview.current.style.color = '';
                const checkIcon = textPreview.current.querySelector('.check-icon');
                if (checkIcon) {
                    checkIcon.remove();
                }
            }
        }
        if (textPreviewBack.current) {
            textPreviewBack.current.innerText = configValue?.statusMessages?.[status] || configValue?.messages?.messageBack;
            if (quality) {
                textPreviewBack.current.style.backgroundColor = 'white';
                textPreviewBack.current.style.color = configValue?.styles?.successColor || '#ACFFB7';
                textPreviewBack.current.style.display = 'flex';
                textPreviewBack.current.style.alignItems = 'center';
                textPreviewBack.current.style.justifyContent = 'center';
                textPreviewBack.current.style.padding = '10px';
                textPreviewBack.current.style.borderRadius = '10px';
                textPreviewBack.current.style.margin = '10px';
                if (!textPreviewBack.current.querySelector('.check-icon')) {
                    const checkIcon = document.createElement('span');
                    checkIcon.innerHTML = '✓';
                    checkIcon.className = 'check-icon';
                    checkIcon.style.marginLeft = '10px';
                    checkIcon.style.fontSize = '20px';
                    checkIcon.style.fontWeight = 'bold';
                    textPreviewBack.current.appendChild(checkIcon);
                }
            } else {
                textPreviewBack.current.style.backgroundColor = '';
                textPreviewBack.current.style.color = '';
                const checkIcon = textPreviewBack.current.querySelector('.check-icon');
                if (checkIcon) {
                    checkIcon.remove();
                }
            }
        }
        if (guideAdo.current) {
            if (quality) {
                guideAdo.current.style.border = `4px solid ${configValue.styles.successColor || '#ACFFB7'}`;
                containerAdo.current?.classList.remove("danger");
            } else if (status === 'no_detected' && takeManualCaptured.current === false) {
                guideAdo.current.style.border = '';
                containerAdo.current?.classList.add("danger");
            } else {
                guideAdo.current.style.border = '';
                containerAdo.current?.classList.remove("danger");
            }
        }
    }, [guideAdo, containerAdo, textPreview, textPreviewBack, configValue]);

    // MODIFICADO: Función para pedir permisos y detectar cámaras (SIN iniciar detección)
    async function requestCameraPermissions() {
        if (permissionsGranted) return;

        setLoading(true);
        try {
            onReportEvent(SDK_EVENT_KEYS.GetCameraPermissions).catch();

            // Pedir permisos de cámara
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            onReportEvent(SDK_EVENT_KEYS.GetCameraPermissionsSuccess).catch();

            // Detener el stream inmediatamente (solo queríamos los permisos)
            stream.getTracks().forEach(track => track.stop());

            setPermissionsGranted(true);
            setLoading(false);
        } catch (error) {
            onReportEvent(SDK_EVENT_KEYS.GetCameraPermissionsDenied).catch();
            setLoading(false);
            responseToHostError(isFront === 'true' ? 'Frontal' : 'Trasera', error.message);
        }
    }


    // MODIFICADO: Función para inicializar la cámara que se llama después del popup
    async function initializeCamera() {
        if (streamInitialized.current || cameraInitialized) return;

        streamInitialized.current = true;
        setCameraInitialized(true);
        setLoading(true);

        if (isFront === 'true' || isFront === 'true/') {
            onReportEvent(SDK_EVENT_KEYS.InitServiceCardCapture).catch();
            setTypeCapture('1');
            const streamProperties = {
                device: initDevice(),
                modelPath: '/models',
                croppedImage: true,
                urlService: configValue.urlService,
                useRegula: configValue?.useRegula || 'false',
                isFront,
                documentType,
                processId,
                codeTransaction,
                onStatusChange: updateDetectorStatus,
                config: configValue,
            };
            const streamRef = Stream.getInstance(streamProperties);
            streamRef.updateHtmlElements(videoRef.current, canvasRef.current, textPreview, textPreviewBack, configValue);
            streamRef.setFaceDetection(true);
            streamRef.setCallbackAutoCapturing(callbackAutoCapturing);
            const faceDetectionErrorsCallback = (status) => {
                if (callbackRef.current) {
                    callbackRef.current(status);
                }
            };
            streamRef.setCallbackFaceDetectionErrors(faceDetectionErrorsCallback);
            isMovil()
                ? startCamera(
                    1,
                    videoRef,
                    canvasRef,
                    containerAdo,
                    Stream,
                    configValue,
                    callbackAutoCapturing,
                    takeManualCaptured,
                    setConfigValues,
                    initTimer,
                    setLoading,
                    responseToHostError,
                    showGuide,
                    undefined,
                    updateDetectorStatus,
                    setCurrentStream,
                    initCameraManualWithUI
                ).then(() => {}).catch()
                : startCameraDesktop(1).then(() => {}).catch();
        } else {
            setTypeCapture('2');
            onReportEvent(SDK_EVENT_KEYS.InitServiceCardCapture).catch();
            const streamProperties = {
                device: initDevice(),
                modelPath: '/models',
                croppedImage: true,
                urlService: configValue.urlService,
                useRegula: configValue?.useRegula || 'false',
                isFront,
                documentType,
                processId,
                codeTransaction,
                onStatusChange: updateDetectorStatus,
                config: configValue,
            };
            const streamRef = Stream.getInstance(streamProperties);
            streamRef.updateHtmlElements(videoRef.current, canvasRef.current, textPreview, textPreviewBack, configValue);
            streamRef.setFaceDetection(true);
            streamRef.setCallbackAutoCapturing(callbackAutoCapturing);
            streamRef.setCallbackFaceDetectionErrors((status) => {
                if (callbackRef.current) {
                    callbackRef.current(status);
                }
            });
            isMovil()
                ? startCamera(
                    2,
                    videoRef,
                    canvasRef,
                    containerAdo,
                    Stream,
                    configValue,
                    callbackAutoCapturing,
                    takeManualCaptured,
                    setConfigValues,
                    initTimer,
                    setLoading,
                    responseToHostError,
                    showGuide,
                    undefined,
                    updateDetectorStatus,
                    setCurrentStream,
                    initCameraManualWithUI
                ).catch()
                : startCameraDesktop(2).catch();
        }
    }

    // MODIFICADO: useEffect para pedir permisos y detectar cámaras al inicio
    useEffect(() => {
        if (!initProcess.current) {
            initProcess.current = true;
            requestCameraPermissions();
        }
    }, []);

    useEffect(() => {
        return () => {
            if (timer) clearInterval(timer);
        };
    }, []);

    async function uploadImage(base64Image) {
        try {
            setShowModalCaptureManual(false);
            onReportEvent(SDK_EVENT_KEYS.CardCaptureInitCaptureManual).catch();
            showGuide(false);
            setLoading(true);

            onReportEvent(SDK_EVENT_KEYS.CardCaptureTakePhoToManual).catch();
            takeOneManualPhoto.current = false;
            isAutoCaptureStopped.current = true;

            onReportEvent(SDK_EVENT_KEYS.CaptureFrame).catch();
            const blobImage = await base64ToBlob(base64Image);
            onReportEvent(SDK_EVENT_KEYS.FrameToBase64).catch();
            onReportEvent(SDK_EVENT_KEYS.FrameSend).catch();

            const response = await documentValidator({
                base64Data: blobImage,
                urlService: configValue.urlService,
                isFront,
                documentType,
                processId,
                config: configValue
            });

            onReportEvent(SDK_EVENT_KEYS.FrameSuccess).catch();
            setLoading(false);

            if (response.data.quality && response.status === 200) {
                let image = base64Image
                if (configValue?.documentValidator?.return_original) {
                    image = response?.data?.images?.original || base64Image
                }
                const finalImage = await rotateBase64Image(image) || base64Image;
                responseToHost(isFront === 'true' ? 1 : 2, finalImage, finalImage);
            } else {
                setErrorCaptureManual({
                    show: true,
                    message: configValue?.statusMessages[response.data.status] || configValue?.statusMessages.no_detected
                })
                // setCameraInitialized(false);
                // setShowModalCaptureManual(true);
            }

        } catch (e) {
            console.error(e);
        }
    }

    function initCameraManualWithUI() {
        const streamRef = Stream.getInstance();
        if (streamRef) {
            streamRef.dropStream();
        }

        if (takeManual.current) {
            takeManual.current.style.display = 'flex';
        }
        takeManualCaptured.current = true;

        if (textPreview.current) {
            textPreview.current.innerText = CONFIG?.messages?.messageFrontTimeout || 'Úbica la parte de adelante tu documento y toma la foto';
        }
        if (textPreviewBack.current) {
            textPreviewBack.current.innerText = CONFIG?.messages?.messageBackTimeout || 'Úbica la parte de atrás de tu cédula y toma la foto';
        }
    }

   function handleFileChange (e){
        const file = e.target.files[0];
       setShowInstructionsCameraNative(false);
       showGuide(false);
       setLoading(true);

        if (file) {
            const reader = new FileReader();

            reader.onload = async function(event) {
                const base64Image = event.target.result;

                if (configValue?.configCamera?.validateDocument) {
                    await uploadImage(base64Image);
                    return
                }
                setShowModalCaptureManual(false);
                const finalImage = await rotateBase64Image(base64Image);
                setLoading(false);
                responseToHost(isFront === 'true' ? 1 : 2, finalImage, finalImage);
            };

            reader.readAsDataURL(file);

        }
    };
    const retryAutomaticCapture = async () => {
        setShowModalCaptureManual(false);
        streamInitialized.current = false
        takeManualCaptured.current = false;
        isAutoCaptureStopped.current = false;
        timerRef.current = 0
        // Iniciar la cámara después de cerrar el popup
        if (initializeCamera) {
            await initializeCamera();
        }
    };
    const triggerCamera = () => {
        inputRef.current.click();
    };
    function detenerCamara(stream) {
        if (stream) {
            const tracks = stream.getTracks();

            tracks.forEach(track => {
                track.stop();
            });

            videoRef.srcObject = null;
        }
    }

    function openCameraNavite() {
        triggerCamera();
    }


    useEffect(() => {
        if (timerRef.current === TIME_TO_CAPTURE_MANUAL && isMovil() && !takeManualCaptured.current) {
            const streamRef = Stream.getInstance();
            // Solo detener la detección automática, mantener el video activo para captura manual
            if (streamRef) {
                streamRef.dropStream();
            }

            if (CONFIG?.configCamera?.useNativeCamera) {
                isAutoCaptureStopped.current = true;
                takeManualCaptured.current = true;

                detenerCamara(currentStream);
                setCameraInitialized(false);
                setShowModalCaptureManual(true);
            } else {
                if (takeManual.current) {
                   takeManual.current.style.display = 'flex';
               }
               takeManualCaptured.current = true;

               if (textPreview.current) {
                   textPreview.current.innerText = CONFIG?.messages?.messageFrontTimeout || 'Úbica la parte de adelante tu documento y toma la foto';
               }
               if (textPreviewBack.current) {
                   textPreviewBack.current.innerText = CONFIG?.messages?.messageBackTimeout || 'Úbica la parte de atrás de tu cédula y toma la foto';
               }
            }

            clearInterval(timer);

            console.log('Timeout alcanzado - Modo manual activado (cámara permanece activa)');
        }
    }, [seconds]);

    return {
        capturedImageBack,
        cameraIsReady,
        isCard,
        canvasPreviewRef,
        indicatorRotate,
        isImageValidate,
        canvasCroppedImageRef,
        ocr,
        debug,
        step,
        stepHistory,
        typeCapture,
        markRef,
        loading,
        projectName,
        platform,
        configLoading,
        openCameraNavite,
        showModalCaptureManual,
        inputRef,
        triggerCamera,
        isMovil,
        goBack,
        takeManualPhoto,
        retryAutomaticCapture,
        handleFileChange,
        emitReadyCam,
        errorCaptureManual,
        setErrorCaptureManual,
        configValue,
        setShowInstructionsCameraNative,
        showInstructionsCameraNative,
        detectorStatus,
        initializeCamera,
        cameraInitialized,
        permissionsGranted
    };
}
